export class VehicleInfoReq{
// vehicleId:number
vehicleNum:string
driverId:number
driverName:string
vehicleAssignId:number
constructor(
    // vehicleId:number,
vehicleNum:string,
driverId:number,
driverName:string,
vehicleAssignId:number

){
    this.driverId = driverId
    this.driverName = driverName
    // this.vehicleId = vehicleId
    this.vehicleNum = vehicleNum
    this.vehicleAssignId = vehicleAssignId
}
}
export class VehicleNumberReq{
    vehicleNum:string
   
    constructor(
    vehicleNum:string,
   
    ){
       
        this.vehicleNum = vehicleNum
    }
    }